import { render, staticRenderFns } from "./PanelBox.vue?vue&type=template&id=66167048&scoped=true"
import script from "./PanelBox.vue?vue&type=script&lang=js"
export * from "./PanelBox.vue?vue&type=script&lang=js"
import style0 from "./PanelBox.vue?vue&type=style&index=0&id=66167048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66167048",
  null
  
)

export default component.exports